export default function BusinessDropdownIcon() {
  return (
    <svg width='16' height='14' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clip-path='url(#clip0_29101_90474)'>
        <path
          d='M4 14.6666V2.66659C4 2.31296 4.14048 1.97382 4.39052 1.72378C4.64057 1.47373 4.97971 1.33325 5.33333 1.33325H10.6667C11.0203 1.33325 11.3594 1.47373 11.6095 1.72378C11.8595 1.97382 12 2.31296 12 2.66659V14.6666H4Z'
          stroke='currentColor'
          stroke-width='1.33333'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
        <path
          d='M4.00065 8H2.66732C2.3137 8 1.97456 8.14048 1.72451 8.39052C1.47446 8.64057 1.33398 8.97971 1.33398 9.33333V13.3333C1.33398 13.687 1.47446 14.0261 1.72451 14.2761C1.97456 14.5262 2.3137 14.6667 2.66732 14.6667H4.00065'
          stroke='currentColor'
          stroke-width='1.33333'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
        <path
          d='M12 6H13.3333C13.687 6 14.0261 6.14048 14.2761 6.39052C14.5262 6.64057 14.6667 6.97971 14.6667 7.33333V13.3333C14.6667 13.687 14.5262 14.0261 14.2761 14.2761C14.0261 14.5262 13.687 14.6667 13.3333 14.6667H12'
          stroke='currentColor'
          stroke-width='1.33333'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
        <path
          d='M6.66602 4H9.33268'
          stroke='currentColor'
          stroke-width='1.33333'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
        <path
          d='M6.66602 6.66675H9.33268'
          stroke='currentColor'
          stroke-width='1.33333'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
        <path
          d='M6.66602 9.33325H9.33268'
          stroke='currentColor'
          stroke-width='1.33333'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
        <path
          d='M6.66602 12H9.33268'
          stroke='currentColor'
          stroke-width='1.33333'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_29101_90474'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
}
